import {
  Client,
  ClientEvent,
  ClientResponse,
  ClientStatus,
  ConversationEvent,
  GetConversationMessagesResponse,
  GetConversationParticipantsResponse,
  StartConversationResponse,
  initObservability,
  GetVerificationCodesResponse,
  InProgressResponse,
  StreamTextResponse,
} from '@stripe-internal/conversations-client';
import {Observable} from 'rxjs';
import {createContext, useContext} from 'react';

const notImplemented = () => {
  throw new Error('not implemented');
};

export const NoClient: Client = {
  channel: 'chat',
  type: 'no-client',
  getVerificationCodes(): Promise<GetVerificationCodesResponse> {
    return notImplemented();
  },
  inProgress(): Promise<InProgressResponse> {
    return notImplemented();
  },
  requestACall(): Promise<ClientResponse> {
    return notImplemented();
  },
  submitEmailIssue(): Promise<ClientResponse> {
    return notImplemented();
  },
  addConversationListener(): void {
    return notImplemented();
  },
  addListener(): void {
    return notImplemented();
  },
  conversationEventsObservable(): Observable<ConversationEvent> {
    return notImplemented();
  },
  disconnect(): Promise<void> {
    return notImplemented();
  },
  eventsObservable(): Observable<ClientEvent> {
    return notImplemented();
  },
  getConversationMessages(): Promise<GetConversationMessagesResponse> {
    return notImplemented();
  },
  getConversationParticipants(): Promise<GetConversationParticipantsResponse> {
    return notImplemented();
  },
  getStatus(): ClientStatus {
    return notImplemented();
  },
  leaveConversation(): Promise<ClientResponse> {
    return notImplemented();
  },
  removeConversationListener(): void {
    return notImplemented();
  },
  removeListener(): void {
    return notImplemented();
  },
  sendConversationMessage(): Promise<ClientResponse> {
    return notImplemented();
  },
  sendConversationTyping(): Promise<ClientResponse> {
    return notImplemented();
  },
  sendFeedback(): Promise<ClientResponse> {
    return notImplemented();
  },
  streamText(): Promise<StreamTextResponse> {
    return notImplemented();
  },
  action(): Promise<ClientResponse> {
    return notImplemented();
  },
  startConversation(): Promise<StartConversationResponse> {
    return notImplemented();
  },
  statusObservable(): Observable<ClientStatus> {
    return notImplemented();
  },
  ...initObservability(),
};

export const ClientContext = createContext<Client>(NoClient);
export const ClientProvider = ClientContext.Provider;
export const ClientConsumer = ClientContext.Consumer;

export const useClient = () => {
  return useContext(ClientContext);
};
